export enum CategoryTypes {
  Media = "media",
  Category = "category",
  External = "external"
}